
export const isProduction = process.env.REACT_APP_BUILD_TYPE === "Production";

export const GoogleAuthApiKey = isProduction ?
    "855557947667-03md0m6ugr3ordr957hqge6ic1pjgeqf.apps.googleusercontent.com"
    : "182477344924-ujahs61mni6sou6hlg9cfmime71a97kd.apps.googleusercontent.com"

export const BASE_URL = isProduction
    ? "https://portal-api.servicemonitor.co.uk"
    : "https://aws-dev-portal-api.servicemonitor.co.uk";

// Sentry browser-side error reporting (empty string disables it). Dedicated
// "Client Portal UI" project in the company Sentry account (EU region).
export const sentryDsn =
    "https://d871156bd1837fbb224c2b03a1bda8bf@o4510188132761600.ingest.de.sentry.io/4512049741889616";

export const endpoints = {
  accountManagement: {
    listAccounts: "/api/v1/userrole/accountmanagementmodule/listaccounts",
    getAccountDetails:
        "/api/v1/userrole/accountmanagementmodule/getaccountdetails",
    requestAccountDetailsUpdate:
        "/api/v1/userrole/accountmanagementmodule/requestaccountdetailsupdate",
  },
  auth: {
    login: "/api/v1/publicrole/authmodule/login",
    refreshAccessToken: "/api/v1/publicrole/authmodule/refresh",
    requestpasswordreset:
        "/api/v1/publicrole/passwordresetmodule/requestpasswordreset",
    resetpassword: "/api/v1/publicrole/passwordresetmodule/resetpassword",
    validateresettoken:
        "/api/v1/publicrole/passwordresetmodule/validateresettoken",
    initialisepassword:
        "/api/v1/publicrole/passwordresetmodule/initialisepassword",
    googleLogin: "/api/v1/publicrole/authmodule/google",
    adLogin: "/api/v1/publicrole/authmodule/saml/token",
    checkIdp: "/api/v1/publicrole/authmodule/checkIdp"
  },
  commentAnalysis: {
    getOverview: "/api/v1/userrole/commentanalysismodule/getoverview",
    downloadOverviewCSV:
        "/api/v1/userrole/commentanalysismodule/downloadoverviewcsv",
    getDetailedAnalysis:
        "/api/v1/userrole/commentanalysismodule/getdetailedanalysis",
    downloadDetailedAnalysisCSV:
        "/api/v1/userrole/commentanalysismodule/downloaddetailedanalysiscsv",
  },
  dashboard: {
    getDashboard: "/api/v1/userrole/dashboardmodule/getdashboard",
    getGraph: "/api/v1/userrole/dashboardmodule/getgraph",
    validateFilters: "/api/v1/userrole/dashboardmodule/validatefilters",
    applyDateFilter: "/api/v1/userrole/dashboardmodule/applyDateFilter",
    getPrintFiles: "/api/v1/userrole/dashboardmodule/getprintfiles",
  },
  downloads: {
    getDownloads: "/api/v1/userrole/downloadsmodule/getdownloads",
  },
  fileModule: {
    downloadFile: "/api/v1/userrole/filemodule/downloadfile",
  },
  guides: {
    listGuides: "/api/v1/userrole/guidesmodule/listguides",
  },
  loginReport: {
    getLoginReport: "/api/v1/userrole/loginreportmodule/getloginreport",
    downloadLoginReportCSV:
        "/api/v1/userrole/loginreportmodule/downloadloginreportcsv",
  },
  pdfReports: {
    getPdfReports: "/api/v1/userrole/pdfreportsmodule/getpdfreports",
  },
  portalConfiguration: {
    getPortalConfiguration:
        "/api/v1/userrole/portalconfigurationmodule/getportalconfiguration",
    getGeneralFilters:
        "/api/v1/userrole/portalconfigurationmodule/getgeneralfilters",
    getReviewFeedFilters:
        "/api/v1/userrole/portalconfigurationmodule/getreviewfeedfilters",
    getCommentAnalysisFilters:
        "/api​/v1​/userrole​/portalconfigurationmodule​/getcommentanalysisfilters",
  },
  projects: {
    listProjectsForUser: "/api/v1/userrole/projectsmodule/listprojectsforuser",
  },
  reviewFeed: {
    listReviews: "/api/v1/userrole/reviewfeedmodule/listreviews",
    downloadReviewFeedCSV:
        "/api/v1/userrole/reviewfeedmodule/downloadreviewfeedcsv",
    flagReview: "/api/v1/userrole/reviewfeedmodule/flagreview",
    submitResponse: "/api/v1/userrole/reviewfeedmodule/submitresponse",
  },
  responseFeedV3: {
    listResponses: "/api/v1/userrole/responsefeedmodulev3/listresponses",
  },
  leagueTable: {
    getLeagueTables: "/api/v1/userrole/leaguetablesmodule/getleaguetables",
    downloadLeagueTablesCSV: "/api/v1/userrole/leaguetablesmodule/downloadleaguetablesdata",
  },
  userManagement: {
    listUsers: "/api/v1/userrole/usermanagementmodule/listusers",
    requestNewUser: "/api/v1/userrole/usermanagementmodule/requestnewuser",
    requestUserUpdate:
      "/api/v1/userrole/usermanagementmodule/requestuserupdate",
    viewUser: "/api/v1/userrole/usermanagementmodule/viewuser",
    requestDeleteUser:
      "/api/v1/userrole/usermanagementmodule/requestdeleteuser",
  },
  quicksight: {
    getPreSignedUrl: "/api/v1/userrole/quicksightmodule/getpresignedurl"
  },
  settings: {
    setSettings: "/api/v1/userrole/settingsmodule/updatesettings",
    getSettings: "/api/v1/userrole/settingsmodule/getsettings",
    getLanguages: "/api/v1/userrole/settingsmodule/getlanguages",
    getDates: "/api/v1/userrole/settingsmodule/getdates",
    deleteReminder: "/api/v1/userrole/settingsmodule/deletereminder",
    showReminder: "/api/v1/userrole/settingsmodule/showreminder"
  }
};
